import { PackOptionsForStreamz, PackOptionsForStreamzB2B, PackOptionsForStreamzBasic, PackOptionsForStreamzBasicB2B } from '../../../constants/pack-options/pack-option.constants';
import { OmapiIdsUtils } from '../omapi-ids/omapi-ids-utils';
var PackOptionUtils = /** @class */ (function () {
    function PackOptionUtils() {
    }
    PackOptionUtils.getCorrectSetOfOptions = function (omapiId) {
        var packOptions;
        switch (omapiId) {
            case OmapiIdsUtils.STREAMZ_DWN_RESIDENTIAL_ID:
                packOptions = PackOptionsForStreamz;
                break;
            case OmapiIdsUtils.STREAMZ_DWN_BUSINESS_ID:
                packOptions = PackOptionsForStreamzB2B;
                break;
            case OmapiIdsUtils.STREAMZ_BASIC_DWN_RESIDENTIAL_ID:
                packOptions = PackOptionsForStreamzBasic;
                break;
            case OmapiIdsUtils.STREAMZ_BASIC_DWN_BUSINESS_ID:
                packOptions = PackOptionsForStreamzBasicB2B;
                break;
        }
        return packOptions;
    };
    return PackOptionUtils;
}());
export { PackOptionUtils };
